import { gql } from '@apollo/client';

export function getProposalMedicalDetails() {
  return gql`
    query getProposalMedicalDetails($id: String!, $isPrincipal: Boolean) {
      Production {
        entities {
          proposal(id: $id) {
            id
            views {
              Production_all {
                properties {
                  Id
                  Type
                  ProposalName
                  ClauseText
                  InternalCode
                  PolicyEffectiveDate
                  PolicyExpiryDate
                  modifiedOn
                  createdOn
                  PolicyCurrency {
                    Code
                    Title
                    Symbol
                  }
                  Status
                  StatusReason
                  MedicalDetailsID {
                    id
                    views {
                      Production_all {
                        properties {
                          Id
                          Class {
                            Code
                            Id
                            Title
                          }
                          Level {
                            Code
                            Id
                            Title
                          }
                          CoversIDText
                          Nssf
                        }
                      }
                    }
                  }
                  PrimaryBPID {
                    id
                    views {
                      SalesforceManagement_all {
                        properties {
                          Code
                          RelatedCompany {
                            Code
                            Title
                          }
                          PersonID {
                            views {
                              SalesforceManagement_all {
                                properties {
                                  FullName
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  LineID {
                    id
                    views {
                      PlanConfigManagement_all {
                        properties {
                          Name
                          ExternalCode
                        }
                      }
                    }
                  }
                  SublineID {
                    id
                    views {
                      PlanConfigManagement_all {
                        properties {
                          Name
                          ExternalCode
                        }
                      }
                    }
                  }
                  PlanID {
                    id
                    views {
                      PlanConfigManagement_all {
                        properties {
                          Name
                          ExternalCode
                          ClauseEditable
                          MaxNbInsured
                          MaxNbBeneficiary
                          GRLimitDays
                          AcalCategory {
                            Id
                            Code
                            Title
                          }
                          Scratching
                          SOSService
                          ReplacementCarApplied
                          ReplacementCarValue
                          ReplacementCarDays
                        }
                      }
                    }
                  }
                  BusinessUserID {
                    views {
                      SalesforceManagement_all {
                        properties {
                          Code
                          AllowPlanCoverEdits
                          AllowClauseEdits
                          EditableLineChargesIDs {
                            id
                            views {
                              PlanConfigManagement_all {
                                properties {
                                  Id
                                }
                              }
                            }
                          }
                          PersonID {
                            views {
                              SalesforceManagement_all {
                                properties {
                                  FullName
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            queries {
              production {
                relatedUsers {
                  createdBy_firstName
                  createdBy_lastName
                  modifiedBy_firstName
                  modifiedBy_lastName
                }
              }
              production {
                pricingOption {
                  policy_PolicyNumber
                  policy_Id
                  policy_IsPrincipal
                  pricingOption_PolicyCost
                  pricingOption_PolicyCostAmount
                  pricingOption_ChargesPercentage
                  pricingOption_TPAFeesType
                  pricingOption_TPAFeesAmount
                  pricingOption_TPAFeesPercentage
                  pricingOption_TPAFeesApplicableOn
                  pricingOption_BasicPremium
                  pricingOption_PlanToPolicyRate
                  pricingOption_NetPremium
                  pricingOption_GrossPremium
                  pricingOption_TaxOnCommissionAmount
                  pricingOption_ReinsuranceTaxAmount
                  pricingOption_MunicipalityTaxAmount
                  pricingOption_TotalPremium
                  pricingOption_ChargesAmount
                  pricingOption_TPAFeesTotalAmount
                  pricingOption_FixedStampAmount
                  pricingOption_ProportionalStampAmount
                  pricingOption_Status
                  pricingOption_createdOn
                  pricingOption_SumInsured
                  pricingOption_PricingOptionCurrency {
                    Symbol
                  }
                }
              }
            }
          }
        }
        queries {
          getInsuredPricingOptionMedical(
            selectedProposalID: $id
            isPrincipal: $isPrincipal
          ) {
            policyPerson_ReferenceNumber
            policyPerson_PrincipalReference
            policyPerson_IsPrincipal
            production_InsuredPricingOptionMedical_Id
            production_InsuredPricingOptionMedical_PolicyPersonID {
              id
              views {
                Production_all {
                  properties {
                    FullName
                    Relation
                  }
                }
              }
            }
            production_InsuredPricingOptionMedical_Age
            production_InsuredPricingOptionMedical_CoverSumInsured
            production_InsuredPricingOptionMedical_SumInsuredIsAdditive
            production_InsuredPricingOptionMedical_CoverNetPremiumValue
            production_InsuredPricingOptionMedical_CoverCharges
            production_InsuredPricingOptionMedical_CoverTPAFees
            production_InsuredPricingOptionMedical_CoverProportionalStamp
            production_InsuredPricingOptionMedical_CoverMunicipalityTax
            production_InsuredPricingOptionMedical_CoverGrossPremium
            production_InsuredPricingOptionMedical_CoverTotalPremium
            production_InsuredPricingOptionMedical_CoverCost

            production_InsuredPricingOptionMedical_CoverClass {
              Title
            }
            production_InsuredPricingOptionMedical_CoverLevel {
              Title
            }
            production_InsuredPricingOptionMedical_CoverFixedStamp
            production_InsuredPricingOptionMedical_CoverNssf
            planSpecificMedical_PolicyCoverID {
              views {
                PlanConfigManagement_all {
                  properties {
                    Name
                  }
                }
              }
            }
          }

          getPolicyPlanCovers(selectedProposalID: $id) {
            production_PolicyPlanCover_ProposalID {
              id
              views {
                Production_all {
                  properties {
                    PolicyCurrency {
                      Code
                      Title
                    }
                  }
                }
              }
            }
            policyCover_Id
            policyCover_Name
            production_PolicyPlanCover_Id
            production_PolicyPlanCover_CoverEffectiveFrom
            production_PolicyPlanCover_CoverEffectiveTo
            production_PolicyPlanCover_CoverPremiumPercentage
            production_PolicyPlanCover_CoverPremiumValue
            production_PolicyPlanCover_ExcessOnClaimType
            production_PolicyPlanCover_ExcessOnClaimAmount
            production_PolicyPlanCover_ExcessOnClaimPercentage
            production_PolicyPlanCover_ExcessOnClaimDays
            production_PolicyPlanCover_ClauseID {
              id
            }
            production_PolicyPlanCover_CoverPremium
            production_PolicyPlanCover_TotalExcessOnClaim
            production_PolicyPlanCover_CoverSumInsuredBasic
            production_PolicyPlanCover_CoverPremiumBasic
            production_PolicyPlanCover_CoverSumInsuredArabic
            production_PolicyPlanCover_CoverPremiumArabic
            planCover_Id
            planCover_PolicyCoverID {
              id
            }
            production_PolicyPlanCover_IsMain
            production_PolicyPlanCover_IsEditable
            production_PolicyPlanCover_CoverSumInsured
            production_PolicyPlanCover_SumInsuredIsAdditive
            production_PolicyPlanCover_IsMandatory
            production_PolicyPlanCover_CoverPremiumType
          }
          getPolicyBusienssPartnerDetails(selectedProposalID: $id) {
            production_PolicyBusinessPartner_Id
            production_PolicyBusinessPartner_BusinessPartnerID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    PersonID {
                      id
                      views {
                        SalesforceManagement_all {
                          properties {
                            FullName
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            production_PolicyBusinessPartner_PlanCommissionType
            production_PolicyBusinessPartner_PlanCommissionRate
            production_PolicyBusinessPartner_CommissionPercentage
            production_PolicyBusinessPartner_PlanCommissionAmount
            production_PolicyBusinessPartner_IsPrimary
            production_PolicyBusinessPartner_ApplicableOn {
              Code
              createdOn
              Status
              Title
            }
            production_PolicyBusinessPartner_Type
            production_PolicyBusinessPartner_PolicyCommissionAmount
          }
          GetPolicyPerson(proposalID: $id) {
            production_PolicyPerson_Id
            production_PolicyPerson_PersonID {
              id
            }
            production_PolicyPerson_Percentage
            production_PolicyPerson_PersonCode
            production_PolicyPerson_FullName
            production_PolicyPerson_Type
            production_PolicyPerson_OwnerIsDifferent

            production_PolicyPerson_IsPrincipal
            production_PolicyPerson_Continuity
            production_PolicyPerson_TPAReference1
            production_PolicyPerson_TPAReference2
            production_PolicyPerson_Relation

            production_PolicyPerson_Remarks
            production_PolicyPerson_Exclusions
            production_PolicyPerson_CardNumber
            production_PolicyPerson_GRLimitDays

            production_PolicyPerson_PersonAddressID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    IsPrimary
                    Address {
                      Country {
                        Id
                        Title
                      }
                      City
                      Street
                      Building
                    }
                  }
                }
              }
            }
            production_PolicyPerson_Address {
              Building
              Street
              City
              Country {
                Id
                Title
              }
              AddressDetails
            }
            production_PolicyPerson_OrderNumber
          }
          GetInsuredMedicalPolicyPerson(proposalID: $id) {
            production_PolicyPerson_Gender
            production_PolicyPerson_TPAReference1
            production_PolicyPerson_TPAReference2
            production_PolicyPerson_Remarks
            production_PolicyPerson_Relation
            production_PolicyPerson_ReferenceNumber
            policyMedical_Nssf
            production_PolicyPerson_AddressType
            production_PolicyPerson_Address {
              AddressDetails
            }
            production_PolicyPerson_PrincipalReference
            production_PolicyPerson_PhoneDetails {
              PhoneNumber
            }
            production_PolicyPerson_OwnerIsDifferent
            production_PolicyPerson_PersonID {
              views {
                SalesforceManagement_all {
                  properties {
                    FirstName
                    MiddleName
                    LastName
                  }
                }
              }
            }
            policyMedical_Class {
              Id
            }
            production_PolicyPerson_Continuity
            production_PolicyPerson_DateOfBirth
            production_PolicyPerson_Exclusions
            policyMedical_Level {
              Id
            }
          }
        }
      }
      Core_CoNSSFOptions: __type(name: "Core_CoNSSFOptions") {
        name
        enumValues {
          name
        }
      }
      Production_ContinuityOptions: __type(
        name: "Production_ContinuityOptions"
      ) {
        name
        enumValues {
          name
        }
      }
      Insurance_InsuredRelations: __type(name: "Insurance_InsuredRelations") {
        name
        enumValues {
          name
        }
      }
      Core {
        lookups {
          medicalClasses {
            Id
            Code
            Title
          }
          medicalLevels {
            Id
            Code
            Title
          }
        }
      }
    }
  `;
}

export function fetchedPersons() {
  return gql`
    query fetchedPersons($searchKeyword: String) {
      SalesforceManagement {
        queries {
          AllActivePersons(searchKeyword: $searchKeyword) {
            salesforceManagement_Person_Id
            salesforceManagement_Person_FullName
            salesforceManagement_Person_PersonCode
          }
        }
      }
    }
  `;
}

export function fetchedPersonAddressList() {
  return gql`
    query fetchedPersonAddressList($selectedPersonID: String) {
      SalesforceManagement {
        queries {
          getPersonAddressListWithoutPagination(
            selectedPersonID: $selectedPersonID
          ) {
            salesforceManagement_PersonAddress_Id
            salesforceManagement_PersonAddress_AddressType
            salesforceManagement_PersonAddress_Address {
              Country {
                Title
              }
              City
              Street
              Building
            }
            salesforceManagement_PersonAddress_IsPrimary
          }
        }
      }
    }
  `;
}

export function getPlanSpecificMedicalCovers() {
  return gql`
    query getPlanSpecificMedicalCovers($selectedPlanID: String!) {
      PlanConfigManagement {
        queries {
          getPlanSpecificMedicalCovers(selectedPlanId: $selectedPlanID) {
            planConfigManagement_PlanSpecificMedical_Id
            planConfigManagement_PlanSpecificMedical_PolicyCoverID {
              id
              views {
                PlanConfigManagement_all {
                  properties {
                    ExternalCode
                    Name
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
}

export function saveProposalDraftMedical() {
  return gql`
    mutation saveProposalDraftMedical(
      $entityId: String!
      $policyPersonInput: [Production_policyPersonInputs!]!
      $costAndChargeInput: Production_CostAndChargesInputs!
      $medicalDetailsInput: Production_PolicyMedicalInputs!
      $medicalPolicyPersonsInput: [Production_MedicalPolicyPersonsInput]
    ) {
      production {
        entities {
          proposal {
            production {
              saveProposalDraftMedical(
                entityId: $entityId
                policyPersonInput: $policyPersonInput
                costAndChargeInput: $costAndChargeInput
                medicalDetailsInput: $medicalDetailsInput
                medicalPolicyPersonsInput: $medicalPolicyPersonsInput
              ) {
                id
              }
            }
          }
        }
      }
    }
  `;
}

export function calculateAndSaveMedical() {
  return gql`
    mutation calculateAndSaveMedical(
      $entityId: String!
      $planId: String!
      $policyCurrency: String!
      $policyEffectiveDate: Date!
      $policyExpiryDate: Date!
      $policyPersonInput: [Production_policyPersonInputs!]!
      $costAndChargeInput: Production_CostAndChargesInputs!
      $medicalDetailsInput: Production_PolicyMedicalInputs!
      $medicalPolicyPersonsInput: [Production_MedicalPolicyPersonsInput]
      $nbOfAdherent: Long!
    ) {
      production {
        entities {
          proposal {
            production {
              calculateAndSaveMedical(
                entityId: $entityId
                planID: $planId
                policyCurrency: $policyCurrency
                policyEffectiveDate: $policyEffectiveDate
                policyExpiryDate: $policyExpiryDate
                policyPersonInput: $policyPersonInput
                costAndChargeInput: $costAndChargeInput
                medicalDetailsInput: $medicalDetailsInput
                medicalPolicyPersonsInput: $medicalPolicyPersonsInput
                nbOfAdherent: $nbOfAdherent
              ) {
                id
              }
            }
          }
        }
      }
    }
  `;
}

export function getExpatClauseList() {
  return gql`
    query getMedicalClauseListForProposal(
      $currentPage: Int!
      $currentPageSize: Int!
      $selectedLineIds: [String]
    ) {
      PlanConfigManagement {
        queries {
          getClauseList(
            selectedLineIds: $selectedLineIds
            pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
          ) {
            paging {
              pageSize
              pageNumber
              totalCount
            }
            items {
              planConfigManagement_Clause_Id
              planConfigManagement_Clause_createdOn
              planConfigManagement_Clause_modifiedOn
              planConfigManagement_Clause_ExternalCode
              planConfigManagement_Clause_Name
              planConfigManagement_Clause_Description

              planConfigManagement_Clause_LineID {
                id
                views {
                  PlanConfigManagement_all {
                    properties {
                      Name
                      Status
                    }
                  }
                }
              }
              planConfigManagement_Clause_Status
            }
          }
        }
      }
    }
  `;
}

export function issuePolicyMedical() {
  return gql`
    mutation issuePolicyMedical($entityId: String!, $clauseText: String!) {
      production {
        entities {
          proposal {
            production {
              issuePolicyMedical(entityId: $entityId, clauseText: $clauseText) {
                Items {
                  EntityTypeId
                  EntityId
                  EntityViewId
                  PropertyId
                  File {
                    fileName
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
}
export function downloadExpatDocument() {
  return gql`
    mutation downloadExpatDocument($entityId: String!) {
      production {
        entities {
          proposal {
            production {
              downloadPolicySampleExpat(entityId: $entityId) {
                EntityTypeId
                EntityId
                EntityViewId
                PropertyId
                File {
                  id
                  fileName
                }
              }
            }
          }
        }
      }
    }
  `;
}

export function uploadMedicalInsuredList() {
  return gql`
    mutation uploadMedicalInsuredList(
      $entityId: String!
      $medicalPolicyPersonsInput: [Production_MedicalPolicyPersonsInput]
    ) {
      production {
        entities {
          proposal {
            production {
              uploadInsuredList(
                entityId: $entityId
                medicalPolicyPersonsInput: $medicalPolicyPersonsInput
              )
            }
          }
        }
      }
    }
  `;
}
